// Import Trumbowyg
import Trumbowyg from "vue-trumbowyg";
import "trumbowyg/dist/plugins/colors/trumbowyg.colors.min.js";

// Import Trumbowyg CSS
import "trumbowyg/dist/ui/trumbowyg.css";
import "trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.css";

export default {
  components: {
    Trumbowyg,
  },

  data() {
    return {
      config: {
        removeformatPasted: true,
        autogrow: false,
        autogrowOnEnter: false,
        imageWidthModalEdit: true,
        btns: [
          ["undo", "redo"],
          ["strong", "em", "del"],
          ["foreColor"],
          ["link"],
          ["justifyLeft", "justifyCenter", "justifyRight", "justifyFull"],
          ["unorderedList", "orderedList"],
          ["horizontalRule"],
          ["removeformat"],
          ["viewHTML", "insertImage"],
          ["fullscreen"],
        ],
        // https://alex-d.github.io/Trumbowyg/documentation/plugins/#plugin-colors
        // https://github.com/Alex-D/Trumbowyg/blob/develop/plugins/colors/trumbowyg.colors.js
        plugins: {
          colors: {
            colorList: [
              "365F92", // blue
              "75923C", // green
            ],
          },
        },
      },
    };
  },
};
